'use strict';

var _commonjsHelpers = require('./_commonjsHelpers-755157d3.js');
var require$$0 = require('react-dom');
var track = require('./track-fa925b7f.js');
var performance = require('./performance-be581d81.js');
var constants = require('./constants-d8339ee1.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var require$$0__default = /*#__PURE__*/_interopDefaultLegacy(require$$0);

var ReactDOM = require$$0__default["default"];
var _require = track.track,
  trackEvent = _require.trackEvent;
var _require2 = performance.performance_1,
  markIfApplies = _require2.markIfApplies,
  measureIfApplies = _require2.measureIfApplies;
var _require3 = constants.constants,
  HYDRATE_TRACK_NAME = _require3.HYDRATE_TRACK_NAME,
  PERFORMANCE_MARK_HYDRATE = _require3.PERFORMANCE_MARK_HYDRATE;
function hydrate(element, container, callback) {
  markIfApplies(PERFORMANCE_MARK_HYDRATE);
  trackEvent(HYDRATE_TRACK_NAME);
  ReactDOM.hydrate(element, container, function () {
    measureIfApplies();
    if (typeof callback === 'function') {
      callback();
    }
  });
}
var hydrate_1 = hydrate;
var hydrate$1 = _commonjsHelpers.getDefaultExportFromCjs(hydrate_1);

exports.hydrate = hydrate$1;
exports.hydrate_1 = hydrate_1;
